import moment from 'moment';
/**
 *  (Horario por default)
 *  invalidTime = moment('6:59 AM', 'hh:mm A');
        if (this.isAssistantServiceType) {
          invalidTime = moment('5:59 AM', 'hh:mm A');
        }
 *
 */
function getVisitDate(visitday, month, year) {
  if (!visitday) return null;

  return new Date(year, month - 1, parseInt(visitday));
}

function getDays(year, month) {
  return new Date(year, month, 0).getDate();
}

/**
 * Validate Start Hour
 * @param {*} item
 * @param {*} contractSchedule
 * @returns true o false
 *  */
function isValidStartHour(item, contractSchedule) {
  let isValid = false;
  const _values = {
    hour: item.hourStartHour,
    min: item.hourStartMinute,
    ampm: item.hourStartTime,
  };
  const visitHour = moment(
    `${_values.hour}:${_values.min} ${_values.ampm}`,
    'h:m A'
  );
  //Validate if the hour is valid and validate against the schedule hour of contract
  if (visitHour.isValid()) {
    const scheduleHour = moment(contractSchedule.start, 'HH:mm:ss');
    isValid = visitHour.isSameOrAfter(scheduleHour);
  }

  return isValid;
}
/**
 * Validate End Hour
 * @param {*} item
 * @param {*} contractSchedule
 * @returns true o false
 */
function isValidEndHour(item, contractSchedule) {
  let isValid = false;
  const _values = {
    hour: item.hourEndHour,
    min: item.hourEndMinute,
    ampm: item.hourEndTime,
  };
  const visitHour = moment(
    `${_values.hour}:${_values.min} ${_values.ampm}`,
    'h:m A'
  );
  if (visitHour.isValid()) {
    const scheduleHour = moment(contractSchedule.end, 'HH:mm:ss');
    isValid = visitHour.isSameOrBefore(scheduleHour);
  }
  return isValid;
}
/**
 * @param {*} startHour
 * @param {*} endHour
 * @returns true o false
 */
function isEndHourBiggerThanStarted(startHour, endHour) {
  const from = moment(
    `${startHour.hour}:${startHour.min} ${startHour.ampm}`,
    'h:m A'
  );
  const to = moment(`${endHour.hour}:${endHour.min} ${endHour.ampm}`, 'h:m A');
  return to.isAfter(from) && !to.isSame(from);
}
/**
 * @param {*} item
 * @returns true o false
 */
function isValidContinuedEndHour(item, contractSchedule) {
  let isValid = false;
  const _values = {
    hour: item.hourContinuedEndHour,
    min: item.hourContinuedEndMinute,
    ampm: item.hourContinuedEndTime,
  };
  const endContinuedHour = moment(
    `${_values.hour}:${_values.min} ${_values.ampm}`,
    'h:m A'
  );
  //Validate the continued End Hour is valid and is after the start hour of the visit
  //Validate the continued End Hour is valid and is before the end hour of the visit
  //and validate against the schedule hour of contract
  if (endContinuedHour.isValid()) {
    const scheduleHour = moment(contractSchedule.end, 'HH:mm:ss');
    const startHour = moment(
      `${item.hourStartHour}:${item.hourStartMinute} ${item.hourStartTime}`,
      'h:m A'
    );
    const endHour = moment(
      `${item.hourEndHour}:${item.hourEndMinute} ${item.hourEndTime}`,
      'h:m A'
    );
    const startContinuedHour = {
      hour: item.hourContinuedStartHour,
      min: item.hourContinuedStartMinute,
      ampm: item.hourContinuedStartTime,
    };
    isValid =
      endContinuedHour.isSameOrBefore(scheduleHour) && //Validate against the schedule hour of contract
      endContinuedHour.isAfter(startHour) && //Validate the continued End Hour is valid and is after the start hour of the visit
      endContinuedHour.isAfter(endHour) && //Validate the continued End Hour is valid and is before the end hour of the visit
      endContinuedHour.isAfter(startContinuedHour); //Validate the continued End Hour is valid and is after the continued start hour of the visit
  }
  return isValid;
}

function isValidContinuedStartHour(item, contractSchedule) {
  let isValid = false;
  const _values = {
    hour: item.hourContinuedStartHour,
    min: item.hourContinuedStartMinute,
    ampm: item.hourContinuedStartTime,
  };
  const continuedStartHour = moment(
    `${_values.hour}:${_values.min} ${_values.ampm}`,
    'h:m A'
  );
  //Validate the continued Start Hour is valid and is after the start hour of the visit
  //and validate against the schedule hour of contract
  if (continuedStartHour.isValid()) {
    const scheduleHour = moment(contractSchedule.start, 'HH:mm:ss');
    const startHour = moment(
      `${item.hourStartHour}:${item.hourStartMinute} ${item.hourStartTime}`,
      'h:m A'
    );
    const endHour = moment(
      `${item.hourEndHour}:${item.hourEndMinute} ${item.hourEndTime}`,
      'h:m A'
    );
    isValid =
      continuedStartHour.isSameOrAfter(scheduleHour) &&
      continuedStartHour.isAfter(startHour) &&
      continuedStartHour.isAfter(endHour); //Validate the continued End Hour is valid and is before the end hour of the visit;
  }
  return isValid;
}

//Validate if the day is a future day
//Validate if the day is a sunday
//Validate if the day is a holiday
//Validate if the day exist in the month
export function validateDayEntry(item, month, year) {
  const validations = [];

  //Validate if day is empty
  if (!item.day) {
    validations.push('No se puede ingresar una visita sin día.');
    return validations;
  }

  const visitDate = getVisitDate(item.day, month, year);
  const currentDate = new Date();
  const visitDayIsFuture = visitDate > currentDate;

  if (visitDayIsFuture) {
    validations.push('No se puede ingresar una visita para un día futuro.');
  }
  if (item.day == 0) {
    validations.push('No se puede ingresar una visita para un domingo.');
  }
  // const daysInMonth = getDays(
  //   new Date().getFullYear(),
  //   this.selectedPeriod.monthNumber
  // );
  const daysInMonth = getDays(year, month);
  if (item.day > daysInMonth) {
    validations.push('No se puede ingresar una visita para un día inválido.');
  }
  //TODO: Feature for Calendar Holidays (BE)
  /*if (this.isHoliday(item.day)) {
    validations.push(
      'No se puede ingresar una visita para un día feriado.'
    );
  }*/
  return validations;
}

/**
 * Validate if the hour is between the start and end hour of the contract
 * and if the hour is not over the limit
 * and if the hour is not before the start hour of the contract
 * and if the hour is not empty
 * @param {*} item
 * @returns array validations
 */
export function validateEmptyTimeEntry(item, contractSchedule) {
  const validations = [];
  const hasEndHourBiggerThanStarted = isEndHourBiggerThanStarted(
    {
      hour: item.hourStartHour,
      min: item.hourStartMinute,
      ampm: item.hourStartTime,
    },
    {
      hour: item.hourEndHour,
      min: item.hourEndMinute,
      ampm: item.hourEndTime,
    }
  );

  if (!isValidStartHour(item, contractSchedule)) {
    //Validate if hour is validated and if it is not empty and show the contract schedule of start Hour
    validations.push(
      'La hora de inicio no es valida y es requerida, debe estar entre ' +
        moment(contractSchedule.start, 'HH:mm').format('hh:mm A') +
        ' y ' +
        moment(contractSchedule.end, 'HH:mm').format('hh:mm A')
    );
  }
  const hasValidEndHour = isValidEndHour(item, contractSchedule);
  if (!hasValidEndHour) {
    validations.push(
      'La hora de fin no es valida y es requerida, debe estar entre ' +
        moment(contractSchedule.start, 'HH:mm').format('hh:mm A') +
        ' y ' +
        moment(contractSchedule.end, 'HH:mm').format('hh:mm A')
    );
  }

  if (!hasEndHourBiggerThanStarted) {
    validations.push('La hora de fin debe ser mayor a la hora de inicio.');
  }

  //Validate if show fields for continued hours then validate
  const hasContinuedHours =
    item.hourContinuedStartHour ||
    item.hourContinuedStartMinute ||
    item.hourContinuedStartTime ||
    item.hourContinuedEndHour ||
    item.hourContinuedEndMinute ||
    item.hourContinuedEndTime;

  if (hasContinuedHours) {
    const hasContinuedStartedHour = isValidContinuedStartHour(
      item,
      contractSchedule
    );
    const hasContinuedEndHour = isValidContinuedEndHour(item, contractSchedule);
    const isContinuedEndHourBiggerThanContinuedStarted = isEndHourBiggerThanStarted(
      {
        hour: item.hourContinuedStartHour,
        min: item.hourContinuedStartMinute,
        ampm: item.hourContinuedStartTime,
      },
      {
        hour: item.hourContinuedEndHour,
        min: item.hourContinuedEndMinute,
        ampm: item.hourContinuedEndTime,
      }
    );

    if (!hasContinuedStartedHour) {
      validations.push(
        'La hora de inicio de la continuación no es válida,  debe estar entre ' +
          (hasValidEndHour
            ? moment(
                `${item.hourEndHour}:${item.hourEndMinute} ${item.hourEndTime}`,
                'HH:mm A'
              ).format('hh:mm A')
            : moment(contractSchedule.start, 'HH:mm').format('hh:mm A')) +
          ' y ' +
          moment(contractSchedule.end, 'HH:mm').format('hh:mm A')
      );
    } else if (!hasContinuedEndHour) {
      validations.push(
        'La hora de fin de la continuación es requerida,  debe estar entre ' +
          (hasContinuedStartedHour
            ? moment(
                `${item.hourContinuedStartHour}:${item.hourContinuedStartMinute} ${item.hourContinuedStartTime}`,
                'HH:mm A'
              ).format('hh:mm A')
            : moment(contractSchedule.start, 'HH:mm').format('hh:mm A')) +
          ' y ' +
          moment(contractSchedule.end, 'HH:mm').format('hh:mm A')
      );
    }

    if (!isContinuedEndHourBiggerThanContinuedStarted) {
      validations.push(
        'La hora de fin de la continuación debe ser mayor a la hora de inicio.'
      );
    }
  }
  return validations;
}

//Validate Contract Rules for the visit
export function validateContractRules(
  therapyCompensatoryInfo,
  hasContractStartDate
) {
  const validations = [];
  if (
    therapyCompensatoryInfo != null &&
    therapyCompensatoryInfo.isTherapyCompensatory &&
    therapyCompensatoryInfo?.therapyCompensatoryBalance
  ) {
    if (
      therapyCompensatoryInfo?.therapyCompensatoryBalance?.pendingBalance <= 0
    ) {
      validations.push(
        'Visita sobrepasa el límite de visitas aprobadas en el contrato de terapias compensatorias.'
      );
    }
  }
  if (!hasContractStartDate) {
    validations.push(
      'No es posible registrar el día ya que no cuenta con la fecha de comienzo.'
    );
  }
  return validations;
}

export function validateVisitShiftDuration(item) {
  const MAX_SHIFT_DURATION_HOURS = 5;
  const validations = [];

  const formatTime = ({ hour, min, ampm }) =>
    moment(`${hour}:${min} ${ampm}`, 'h:mm A');

  const start = formatTime({
    hour: item.hourStartHour,
    min: item.hourStartMinute,
    ampm: item.hourStartTime,
  });

  const end = formatTime({
    hour: item.hourEndHour,
    min: item.hourEndMinute,
    ampm: item.hourEndTime,
  });

  const durationHours = moment.duration(end.diff(start)).asHours();

  if (durationHours > MAX_SHIFT_DURATION_HOURS) {
    validations.push(
      'El registro de horas no puede superar las 5 horas consecutivas sin tomar una hora para su periodo de alimentación.'
    );
  }

  return validations;
}
